import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity'
import { createReducer, on, Action } from '@ngrx/store'

import * as CustomerPaymentMethodsActions from './customer-payment-methods.actions'
import { CustomerPaymentMethodsEntity } from './customer-payment-methods.models'

export const CUSTOMER_PAYMENT_METHODS_FEATURE_KEY = 'customerPaymentMethods'

export interface State extends EntityState<CustomerPaymentMethodsEntity> {
  selectedId: string // which CustomerPaymentMethods record has been selected
  loaded: boolean // has the CustomerPaymentMethods list been loaded
}

export interface CustomerPaymentMethodsPartialState {
  readonly [CUSTOMER_PAYMENT_METHODS_FEATURE_KEY]: State
}

export const customerPaymentMethodsAdapter: EntityAdapter<CustomerPaymentMethodsEntity> =
  createEntityAdapter<CustomerPaymentMethodsEntity>()

export const initialState: State = customerPaymentMethodsAdapter.getInitialState({
  // set initial required properties
  selectedId: '',
  loaded: true,
  error: '',
})

const reducer = createReducer(
  initialState,
  on(CustomerPaymentMethodsActions.loadCustomerPaymentMethods, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(CustomerPaymentMethodsActions.loadCustomerPaymentMethodsSuccess, (state, { customerPaymentMethods }) =>
    customerPaymentMethodsAdapter.setAll(customerPaymentMethods, {
      ...state,
      loaded: true,
    }),
  ),
  on(CustomerPaymentMethodsActions.setSelectedCustomerPaymentMethod, (state, { paymentMethodId }) => ({
    ...state,
    selectedId: paymentMethodId,
  })),
  on(CustomerPaymentMethodsActions.clearSelectedCustomerPaymentMethod, (state) => ({
    ...state,
    selectedId: '',
  })),
  on(CustomerPaymentMethodsActions.clearCustomerPaymentMethods, () => ({
    ...initialState,
  })),
)

export function customerPaymentMethodsReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}
